import { forwardRef } from "react";

import { INPUT_CLASS_NAME } from "./const";
import { TextAreaProps } from "./type";

/**
 * rowsデフォルト値: 2
 * colsデフォルト値: 20
 */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ isError = false, rows = 2, cols = 20, fullHeight = false, block = false, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      cols={cols}
      {...props}
      className={INPUT_CLASS_NAME({ error: isError, fullHeight, block })}
      style={fullHeight ? {} : { height: `${rows * 2.8}em` }}
    />
  ),
);

TextArea.displayName = "TextArea";
